import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fdbc809"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-content flex justify-content-center p-2" }
const _hoisted_2 = { class: "centered-content flex-grow-1" }
const _hoisted_3 = { class: "category-container flex flex-wrap mt-4 mb-4" }
const _hoisted_4 = { class: "search-container flex pannel align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ci-action-search" }, null, -1))
const _hoisted_6 = { class: "app-label-small font-bold text-gray-l1" }
const _hoisted_7 = { class: "app-label-small text-gray-l1 font-bold" }
const _hoisted_8 = { class: "app-label-small font-bold text-gray-l1" }
const _hoisted_9 = { class: "app-label-small font-bold text-gray-l1" }
const _hoisted_10 = { class: "flex align-items-center w-full" }
const _hoisted_11 = {
  key: 1,
  class: "app-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryCard = _resolveComponent("CategoryCard")!
  const _component_Column = _resolveComponent("Column")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CategoryCard, {
          class: "bg-white cursor-pointer action",
          iconClass: "ci-action-add",
          label: "Faire une nouvelle demande",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onNewDemandButtonClick($event)))
        }),
        _createVNode(_component_CategoryCard, {
          class: "bg-gray-l1 text-white",
          iconClass: ['ci-data-presence', 'text-white'],
          count: _ctx.rgpdFiles.length,
          label: "Fichiers total"
        }, null, 8, ["count"]),
        _createVNode(_component_CategoryCard, {
          class: "bg-green text-white",
          iconClass: ['ci-icon-account', 'text-white'],
          count: _ctx.userData,
          label: "Données Utilisateurs"
        }, null, 8, ["count"]),
        _createVNode(_component_CategoryCard, {
          class: "bg-green text-white",
          iconClass: ['ci-icon-account', 'text-white'],
          count: _ctx.buildingdata,
          label: "Données bâtiments"
        }, null, 8, ["count"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          class: "flex app-label-small text-gray-l1 font-bold search w-full ml-1",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
          placeholder: "Rechercher"
        }, null, 512), [
          [_vModelText, _ctx.filters['global'].value]
        ])
      ]),
      _createVNode(_component_DataTable, {
        value: _ctx.rgpdFiles,
        filters: _ctx.filters,
        "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters) = $event)),
        responsiveLayout: "stack",
        globalFilterFields: ['address_building', 'label', 'stringdate'],
        class: "mb-3"
      }, {
        empty: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
                  key: 0,
                  mode: "indeterminate",
                  class: "h-2rem md:h-5rem"
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, "Aucun fichier disponible"))
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "label",
            header: "label",
            sortable: ""
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(data.label), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "label_building",
            header: "NOM BATIMENT",
            sortable: true
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_7, _toDisplayString(data.label_building), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "address_building",
            header: "ADRESSE",
            sortable: true
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("span", _hoisted_8, _toDisplayString(data.address_building), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "stringdate",
            header: "DATE DE DEMANDE",
            sortable: true
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("span", _hoisted_9, _toDisplayString(data.stringdate), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "url",
            header: "TELECHARGEMENT"
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_app_button, {
                buttonType: "main",
                buttonSize: "s",
                buttonText: "Télécharger",
                isDisabled: false,
                onClick: ($event: any) => (_ctx.downloadFile(data.file_url, data.label))
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "filters"])
    ])
  ]))
}